import React from 'react';
import { TextMessage } from 'components/tt-forms/common';
import { connect } from 'react-redux';
import { NhiemVuTTXM } from 'modules/giai-quyet-don/subView';
import { browserHistory } from 'react-router';
import { ContainerFileDinhKem } from 'components/upload';

class NhapThongTinToTTXMView extends React.Component {

  onClickClose() {
    browserHistory.goBack();
  }

  render() {
    let lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    let isQuaHan = (this.props.donInfo && this.props.donInfo.thoiHanTTXMInfo && this.props.donInfo.thoiHanTTXMInfo.value < 0) ? true : false;
    return (
      <div className="items-form">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.props.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.props.ngayBatDauTTXM}
          donInfo = {this.props.donInfo}
          yKienCuaDonViGiaoTTXM = {this.props.yKienCuaDonViGiaoTTXM}
          ngayHetHanTTXM={this.props.ngayHetHanTTXM}/>
        <div className="wrap-big-line pt10 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Báo cáo kết quả xác minh{lb2}</h2>
        <div className="row pl10 pr10">
          <div className="col-100">
            <div className="col-100 no-gutter mb15">
              <div className="col-100 no-gutter">
                <TextMessage className="col-100 no-gutter" label="Ý kiến xử lý:" value={this.props.noiDungTraBaoCaoTTXMLan2 ? this.props.noiDungTraBaoCaoTTXMLan2 : this.props.noiDungTraBaoCaoTTXMLan1} />
              </div>
            </div>
            {isQuaHan && <TextMessage className="col-100 no-gutter" label="Lý do quá hạn:" value={this.props.donInfo.lyDoQuaHan || ''} />}
          </div>
        </div>
        <div className="container-filedinhkem mt5">
          <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true} />
        </div>
      </div>
    );
  }
}

export default connect()(NhapThongTinToTTXMView);


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-giai-quyet/chuyen-vien/NhapThongTinToTTXMView.jsx